export default __webpack_public_path__ + "static/home_cards_pr-76ca646ebc7efc98d9e864b1934a3213.png";